import blogFetch from "../../axios/config";
import Navbar from "../../layout/Navbar/Navbar";
import Sidebar from "../../layout/Sidebar/SideBar";
import { useEffect, useRef, useState, useMemo, useCallback } from "react";
import "./ListMontagem.css";
import Loading from "../../components/Loading";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import QRCodeReaderListaMontagem from "./QRCodeReaderListaMontagem";

// Constantes fora do componente para evitar recriação a cada render
const IMAGEM_BASE_URL = "https://ingsglass.file.core.windows.net/ingsglass/BRASIL/";
const SAS_TOKEN = ".jpg?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwlacupitfx&se=2033-05-04T04:42:27Z&st=2023-05-03T20:42:27Z&spr=https,http&sig=DBpnOqlwSWJgqZgPjRm5uCJ%2BgUIWicQ5cKPNhUQfNWI%3D";

// Chave do localStorage
const STORAGE_KEY = "listaMontagem_matriculas_SAP";

export default function ListMontagem() {
    // Estados de Autenticação
    const [autenticado, setAutenticado] = useState(false);
    const [matriculaDupla, setMatriculaDupla] = useState({
        principal: "",
        secundaria: ""
    });
    const [modalLoginAberto, setModalLoginAberto] = useState(true);
    const [matriculaTempPrinc, setMatriculaTempPrinc] = useState("");
    const [matriculaTempSec, setMatriculaTempSec] = useState("");
    const [erroValidacao, setErroValidacao] = useState("");

    // Estados de Dados
    const [dadosTabela, setDadosTabela] = useState([]); // Dados já unidos (montagem + componente)
    const [cabecalho, setCabecalho] = useState(null);
    const [imagemUrl, setImagemUrl] = useState(null);
    const [logoUrl, setLogoUrl] = useState(null);
    const [enviandoApontamento, setEnviandoApontamento] = useState(false);

    // Estados de Controle
    const [ordem, setOrdem] = useState("");
    const [loading, setLoading] = useState(false);
    const [zoomAtivo, setZoomAtivo] = useState(false);
    const [codigoLido, setCodigoLido] = useState("");

    const inputRef = useRef(null);
    const abortControllerRef = useRef(null);

    // Carrega matrículas do localStorage ao montar o componente
    useEffect(() => {
        const matriculasSalvas = localStorage.getItem(STORAGE_KEY);

        if (matriculasSalvas) {
            try {
                const dados = JSON.parse(matriculasSalvas);

                // Valida se os dados salvos são válidos
                if (dados.principal && dados.secundaria) {
                    setMatriculaDupla(dados);
                    setAutenticado(true);
                    setModalLoginAberto(false);

                    // Foca no input de ordem após carregar sessão
                    setTimeout(() => {
                        if (inputRef.current) {
                            inputRef.current.focus();
                        }
                    }, 100);
                }
            } catch (error) {
                console.error("Erro ao carregar matrículas do localStorage:", error);
                // Se houver erro, limpa o localStorage
                localStorage.removeItem(STORAGE_KEY);
            }
        }
    }, []);

    // Função para validar matrícula SAP (6 caracteres numéricos)
    const validarMatriculaSAP = (matricula) => {
        // Remove espaços em branco
        const matriculaLimpa = matricula.trim();

        // Verifica se tem exatamente 6 caracteres
        if (matriculaLimpa.length !== 6) {
            return {
                valido: false,
                mensagem: "A matrícula SAP deve ter exatamente 6 caracteres"
            };
        }

        // Verifica se é numérico
        if (!/^\d{6}$/.test(matriculaLimpa)) {
            return {
                valido: false,
                mensagem: "A matrícula SAP deve conter apenas números"
            };
        }

        return { valido: true, mensagem: "" };
    };

    // Função auxiliar para focar e selecionar o texto
    const selectInputText = useCallback(() => {
        setTimeout(() => {
            if (inputRef.current) {
                inputRef.current.focus();
                inputRef.current.select();
            }
        }, 50);
    }, []);

    // Formatar input para aceitar apenas números e limitar a 6 caracteres
    const handleMatriculaChange = (valor, setter) => {
        // Remove tudo que não é número
        const apenasNumeros = valor.replace(/\D/g, '');
        // Limita a 6 caracteres
        const limitado = apenasNumeros.slice(0, 6);
        setter(limitado);

        // Limpa erro quando usuário começa a digitar
        if (erroValidacao) {
            setErroValidacao("");
        }
    };

    // Função de Login
    const handleLogin = () => {
        // Limpa mensagem de erro anterior
        setErroValidacao("");

        // Valida matrícula principal
        const validacaoPrinc = validarMatriculaSAP(matriculaTempPrinc);
        if (!validacaoPrinc.valido) {
            setErroValidacao(`Matrícula Principal: ${validacaoPrinc.mensagem}`);
            return;
        }

        // Valida matrícula secundária
        const validacaoSec = validarMatriculaSAP(matriculaTempSec);
        if (!validacaoSec.valido) {
            setErroValidacao(`Matrícula Secundária: ${validacaoSec.mensagem}`);
            return;
        }

        // Se passou nas validações, salva as matrículas
        const matriculas = {
            principal: matriculaTempPrinc.trim(),
            secundaria: matriculaTempSec.trim()
        };

        // Salva no estado
        setMatriculaDupla(matriculas);
        setAutenticado(true);
        setModalLoginAberto(false);

        // Salva no localStorage
        localStorage.setItem(STORAGE_KEY, JSON.stringify(matriculas));

        // Limpa os campos temporários
        setMatriculaTempPrinc("");
        setMatriculaTempSec("");
        setErroValidacao("");

        // Foca no input de ordem após login
        setTimeout(() => {
            if (inputRef.current) {
                inputRef.current.focus();
            }
        }, 100);

        console.log("✅ Login realizado e salvo no localStorage:", matriculas);
    };

    // Função de Logout
    const handleLogout = () => {
        // Limpa o localStorage
        localStorage.removeItem(STORAGE_KEY);
        console.log("🚪 Logout realizado - localStorage limpo");

        // Limpa todos os estados
        setAutenticado(false);
        setMatriculaDupla({ principal: "", secundaria: "" });
        setOrdem("");
        setDadosTabela([]);
        setCabecalho(null);
        setImagemUrl(null);
        setLogoUrl(null);
        setZoomAtivo(false);
        setCodigoLido("");
        setErroValidacao("");

        // Abre o modal de login novamente
        setModalLoginAberto(true);
    };

    const fetchData = useCallback(async (numeroOrdem) => {
        // Bloqueia se não estiver autenticado
        if (!autenticado) {
            alert("Você precisa fazer login primeiro!");
            return;
        }

        if (!numeroOrdem) return;

        // Cancela requisição anterior se houver (evita race condition)
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }
        abortControllerRef.current = new AbortController();
        const signal = abortControllerRef.current.signal;

        setLoading(true);
        // Limpa estados visuais para dar feedback de "nova busca"
        setImagemUrl(null);
        setLogoUrl(null);
        setCabecalho(null);
        setDadosTabela([]);

        try {
            // Executa requisições independentes em PARALELO (muito mais rápido)
            const [resMontagens, resImagemInfo, resComponentes, resCabecalhoInfo] = await Promise.all([
                blogFetch.get(`MaterialReserve/${numeroOrdem}`, { signal }),
                blogFetch.get(`SAGAViewFichaCabecalho/${numeroOrdem}`, { signal }),
                blogFetch.get(`SAGAViewFichaComponentes/caracteristica/${numeroOrdem}`, { signal }),
                blogFetch.get(`SAGAViewFichaComponentes/cabecalho/${numeroOrdem}`, { signal })
            ]);

            // 1. Processa Imagem Principal
            if (resImagemInfo.data && resImagemInfo.data[0]) {
                const imagemCodigo = resImagemInfo.data[0]._Plano;
                setImagemUrl(`${IMAGEM_BASE_URL}${imagemCodigo}${SAS_TOKEN}`);
            }

            console.log(numeroOrdem);

            await blogFetch.post("IAcompanhamentoMontagem/acompanhamento", { Ordem: numeroOrdem });

            // 2. Processa Cabeçalho e Logo (Se necessário)
            const dadosCabecalho = resCabecalhoInfo.data;
            setCabecalho(dadosCabecalho);

            if (dadosCabecalho?.logo_Tipo === "INTERNO" && dadosCabecalho?.logoID) {
                try {
                    const { data: dataLogo } = await blogFetch.get(
                        `SAP_Etiqueta_Logistica/LogoID?LogoID=${dadosCabecalho.logoID}`,
                        { signal }
                    );
                    setLogoUrl(dataLogo.logoUrl);
                } catch (err) {
                    console.warn("Erro ao buscar logo:", err);
                }
            }

            // 3. Processa e Cruza Dados da Tabela (Lógica Otimizada)
            const listaMontagens = resMontagens.data || [];
            const listaComponentes = resComponentes.data || [];

            // Cria um Mapa (Dicionário) dos componentes para busca rápida O(1)
            const componentesMap = new Map();
            listaComponentes.forEach(comp => {
                componentesMap.set(String(comp.pos), comp); // Garante que a chave seja string
            });

            // Filtra e Mapeia de uma vez só
            const dadosProcessados = listaMontagens
                .filter(m =>
                    !m.COD_MATERIAL.startsWith("303") &&
                    !m.ORDEM_MATERIAL.endsWith("99") &&
                    !m.MATERIAL.includes("FLEXILINE")
                )
                .map(m => {
                    const comp = componentesMap.get(String(m.ORDEM_MATERIAL));
                    return {
                        ...m,
                        descricaoEng: comp?.descricao_Eng || "-"
                    };
                });

            setDadosTabela(dadosProcessados);

        } catch (error) {
            if (error.name !== "CanceledError" && error.message !== "canceled") {
                console.error("Erro ao buscar dados:", error);
                setDadosTabela([]);
            }
        } finally {
            // Só tira o loading se a requisição não foi cancelada
            if (!signal.aborted) {
                setLoading(false);
            }
        }
    }, [autenticado]);

    // Handlers de Input
    const handleKeyDown = (e) => {
        if (!autenticado) {
            e.preventDefault();
            alert("Faça login primeiro!");
            return;
        }

        if (e.key === "Enter") {
            const value = e.target.value.trim();
            if (value !== "") {
                fetchData(value);
                selectInputText();
            }
        }
    };

    const confirmarApontamento = async () => {
        try {
            setEnviandoApontamento(true);

            await blogFetch.post("IAcompanhamentoMontagem/acompanhamento", {
                ordem,
                PrincipalApontamento: matriculaDupla.principal,
                SecundarioApontamento: matriculaDupla.secundaria
            });

            // segue fluxo normal
            localStorage.setItem("ordemApontamento", ordem);
            window.location.href = "/Apontamento_SAP";
        } catch (error) {
            console.error("Erro ao apontar:", error);
        } finally {
            setEnviandoApontamento(false);
        }
    };

    const handleApontar = () => {
        if (!autenticado) {
            alert("Faça login primeiro!");
            return;
        }
        if (!ordem) return;

        confirmarApontamento();
    };

    // Effects
    useEffect(() => {
        if (codigoLido && autenticado) {
            setOrdem(codigoLido); // Atualiza o input visualmente
            fetchData(codigoLido);
            setCodigoLido("");
            selectInputText();
        }
    }, [codigoLido, autenticado, fetchData, selectInputText]);

    return (
        <div className="container_listaMontagem">
            <Navbar />
            <Sidebar />

            <div className="app_body appBody_listaMontagem">
                <div className="row_listaMontagem">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                        <h1 className="titulo_listaMontagem">Listagem de Montagem</h1>

                        {autenticado && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                <span style={{ fontSize: '14px', color: '#666' }}>
                                    <strong>Matrículas SAP:</strong> {matriculaDupla.principal} / {matriculaDupla.secundaria}
                                </span>
                                <button
                                    className="btnLogout"
                                    onClick={handleLogout}
                                    style={{
                                        padding: '8px 16px',
                                        backgroundColor: '#dc2626',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '6px',
                                        cursor: 'pointer',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        transition: 'background-color 0.2s'
                                    }}
                                    onMouseOver={(e) => e.target.style.backgroundColor = '#b91c1c'}
                                    onMouseOut={(e) => e.target.style.backgroundColor = '#dc2626'}
                                >
                                    🚪 Logout
                                </button>
                            </div>
                        )}
                    </div>

                    <div className="inputWrapper_listaMontagem">
                        <QRCodeReaderListaMontagem
                            setCode={setCodigoLido}
                        />

                        <input
                            type="text"
                            ref={inputRef}
                            className="inputOrdem_listaMontagem"
                            placeholder={autenticado ? "Digite o número da ordem" : "Faça login primeiro"}
                            value={ordem}
                            onChange={(e) => setOrdem(e.target.value)}
                            onKeyDown={handleKeyDown}
                            autoComplete="off"
                            disabled={!autenticado}
                            style={{
                                opacity: autenticado ? 1 : 0.5,
                                cursor: autenticado ? 'text' : 'not-allowed'
                            }}
                        />
                    </div>

                    <div className="listaMontagemContainer">
                        {!autenticado ? (
                            <div style={{ textAlign: 'center', marginTop: '50px', color: '#666' }}>
                                <p style={{ fontSize: '18px' }}>🔒 Faça login com as matrículas SAP para acessar a listagem de montagem</p>
                            </div>
                        ) : loading ? (
                            <div className="loadingContainer">
                                <Loading />
                            </div>
                        ) : dadosTabela.length > 0 ? (
                            <div className="conteudo_listaMontagem">
                                <div className="tabelaWrapper_listaMontagem">
                                    <table className="tabela_listaMontagem">
                                        <thead>
                                            <tr>
                                                <th>Caract</th>
                                                <th>Código</th>
                                                <th>Posição</th>
                                                <th>Material</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {dadosTabela.map((item, index) => (
                                                <tr key={`montagem-${item.ORDEM_MATERIAL}-${index}`}>
                                                    <td>{item.descricaoEng}</td>
                                                    <td>{item.COD_MATERIAL}</td>
                                                    <th>{item.ORDEM_MATERIAL}</th>
                                                    <th>{item.MATERIAL}</th>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                    <button
                                        className="btnAbrirImagemCompleta_listaMontagem"
                                        onClick={() => setZoomAtivo(true)}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7" />
                                        </svg>
                                        <span>Expandir Imagem</span>
                                    </button>
                                </div>

                                {/* === BLOCO DE INFORMAÇÕES ADICIONAIS === */}
                                <div className="infoExtra_listaMontagem">
                                    <div className="dadosTecnicos_listaMontagem">
                                        <h3>Dados Técnicos</h3>
                                        <ul>
                                            <li><span>Acabamento do CP:</span> <strong>{cabecalho?.acabamento || "-"}</strong></li>
                                            <li><span>Tipo do Policarbonato:</span> <strong>{cabecalho?.pc || "-"}</strong></li>
                                            <li><span>Ciclo da Autoclave:</span> <strong>{cabecalho?.ciclo_Autoclave || "-"}</strong></li>
                                            <li><span>Logo Tipo:</span> <strong>{cabecalho?.logo_Tipo || "-"}</strong></li>
                                        </ul>
                                    </div>

                                    <div className="imagemExtraWrapper_listaMontagem">
                                        <h3>Logo</h3>
                                        {logoUrl ? (
                                            <img src={logoUrl} alt="Logo" className="imagemExtra_listaMontagem" />
                                        ) : (
                                            <div className="imagemPlaceholder_listaMontagem">
                                                Nenhuma imagem disponível
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* === MODAL DE ZOOM === */}
                                {zoomAtivo && imagemUrl && (
                                    <div className="zoomModal_overlay">
                                        <TransformWrapper
                                            initialScale={1}
                                            minScale={1}
                                            maxScale={6}
                                            wheel={{ step: 0.2 }}
                                            doubleClick={{ disabled: true }}
                                        >
                                            {({ zoomIn, zoomOut, resetTransform }) => (
                                                <div className="zoomArea">
                                                    <div className="zoomControls">
                                                        <button onClick={() => zoomIn()}>➕</button>
                                                        <button onClick={() => zoomOut()}>➖</button>
                                                        <button onClick={() => resetTransform()}>↩</button>
                                                        <button
                                                            title="Fechar"
                                                            onClick={() => setZoomAtivo(false)}
                                                            style={{ background: '#dc2626' }}
                                                        >✕</button>
                                                    </div>
                                                    <TransformComponent>
                                                        <img
                                                            src={imagemUrl}
                                                            alt="Zoom"
                                                            className="zoomModal_image"
                                                            draggable="false"
                                                        />
                                                    </TransformComponent>
                                                </div>
                                            )}
                                        </TransformWrapper>
                                    </div>
                                )}

                                <div className="acaoFinal_listaMontagem">
                                    <button
                                        className="btnApontarOrdem"
                                        onClick={handleApontar}
                                    >
                                        Apontar
                                    </button>
                                </div>
                            </div>
                        ) : (
                            ordem && !loading && <p style={{ textAlign: 'center', marginTop: '20px' }}>Nenhuma informação encontrada ou aguardando leitura.</p>
                        )}
                    </div>
                </div>
            </div>

            {/* MODAL DE LOGIN */}
            {modalLoginAberto && (
                <div className="modal_overlay">
                    <div className="modal_container">
                        <h3>🔐 Login da Dupla - SAP</h3>
                        <p style={{ fontSize: '14px', color: '#666', marginBottom: '20px' }}>
                            Informe as <strong>matrículas SAP</strong> (6 dígitos) para acessar o sistema
                        </p>

                        {erroValidacao && (
                            <div style={{
                                backgroundColor: '#fee',
                                border: '1px solid #fcc',
                                color: '#c33',
                                padding: '10px',
                                borderRadius: '4px',
                                marginBottom: '15px',
                                fontSize: '13px',
                                textAlign: 'center'
                            }}>
                                ⚠️ {erroValidacao}
                            </div>
                        )}

                        <div style={{ marginBottom: '10px' }}>
                            <label style={{
                                display: 'block',
                                fontSize: '13px',
                                color: '#555',
                                marginBottom: '5px',
                                fontWeight: '500'
                            }}>
                                Matrícula SAP Principal *
                            </label>
                            <input
                                type="text"
                                className="inputModalMatricula"
                                value={matriculaTempPrinc}
                                onChange={(e) => handleMatriculaChange(e.target.value, setMatriculaTempPrinc)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        handleLogin();
                                    }
                                }}
                                maxLength={6}
                                autoFocus
                                style={{
                                    fontFamily: 'monospace',
                                    fontSize: '16px',
                                    letterSpacing: '2px',
                                    textAlign: 'center'
                                }}
                            />
                        </div>

                        <div style={{ marginBottom: '20px' }}>
                            <label style={{
                                display: 'block',
                                fontSize: '13px',
                                color: '#555',
                                marginBottom: '5px',
                                fontWeight: '500'
                            }}>
                                Matrícula SAP Secundária *
                            </label>
                            <input
                                type="text"
                                className="inputModalMatricula"
                                value={matriculaTempSec}
                                onChange={(e) => handleMatriculaChange(e.target.value, setMatriculaTempSec)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        handleLogin();
                                    }
                                }}
                                maxLength={6}
                                style={{
                                    fontFamily: 'monospace',
                                    fontSize: '16px',
                                    letterSpacing: '2px',
                                    textAlign: 'center'
                                }}
                            />
                        </div>

                        <div className="modal_actions">
                            <button
                                className="btnConfirmar"
                                onClick={handleLogin}
                                style={{ width: '100%' }}
                                disabled={matriculaTempPrinc.length !== 6 || matriculaTempSec.length !== 6}
                            >
                                ✓ Entrar
                            </button>
                        </div>
                                
                    </div>
                </div>
            )}
        </div>
    );
}